module.exports = __webpack_public_path__ + "static/media/municipios.cb74932d.jpg";